import * as React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  currency: string;
  amount: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const JackpotMoneyBox: React.FC<Props> = ({ currency, amount }) => {
  const { t } = useTranslation();

  return (
    <div className="money_box">
      <div className="box">
        <p>{t("panel.drawingPanel.comingSoon")}</p>
      </div>
    </div>
  );
};

export default JackpotMoneyBox;
